import {
  Stack,
  StackProps
} from '@mui/material';
import React, { ReactNode } from 'react';



export type ActivitySectionLayoutProps = {
  children?: ReactNode;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ActivitySectionLayoutProps & StackProps) => {

  return (
    <Stack
      direction='column'
      rowGap='1.5rem'
      {...props}
    >
      {props.children}
    </Stack>
  );
};
